<template>
  <div>
    <div v-if="values.length === 0" class="form-inline">
      Select number of options to add:
      <input v-model="optionsCount"
             class="form-control"
             type="number"
             :min="2"/>
      <button class="btn right green"
         :disabled="!optionsCount || optionsCount < 2"
         @click="setOptionsCount(optionsCount)">
        Add Options
      </button>
      <button class="btn right green"
              v-if="showTemplates"
              @click="showAddFromTemplate()">
        Choose from template
      </button>
    </div>
    <div v-if="values.length > 0">
      <label>Values</label>
      <draggable tag="ul"
                 :list="values"
                 class="list-group"
                 :handle="'.list-group-item'"
                 :group="{name: 'options', pull: false}"
      >
        <li v-for="(option, index) in values" :key="'rating-item' + index"
            class="list-group-item">
          <div class="row no-margin-bot">
            <div class="input-field"
                 :class="{ 'col-md-10': !editValue, 'col-md-5': editValue}">
              <label class="active"
                     :for="id+'-option-label-' + index">Label</label>
              <input :id="id+'-option-label-' + index" type="text"
                     class="form-control"   v-model="option.label">
            </div>
            <div v-if="editValue"
                 class="col-md-5 input-field">
              <label class="active"
                     :for="id+'-option-value-' + index">Value</label>
              <input :id="id+'-option-value-' + index" type="text"
                     class="form-control"  v-model="option.value">
            </div>
            <div class="middle" v-if="values.length > 2">
              <i class="fa fa-times" @click.stop="removeOption(values, index)"></i>
            </div>
          </div>
        </li>
      </draggable>

      <div class="row">
        <div class="col-md-12">
          <a class="btn right green" @click.stop="addOption(values)">Add Option</a>
          <button class="btn right green"
                  v-if="showTemplates"
                  @click="showAddFromTemplate()">
            Choose from template
          </button>
        </div>
      </div>
    </div>
    <select-field-template-modal :id="modalId"
                                 v-if="showTemplates"
                                 @confirmed="addFromTemplate"/>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import draggable from 'vuedraggable';

import SelectFieldTemplateModal from '@/components/modals/SelectFieldTemplateModal';

export default {
  components: {
    draggable,
    SelectFieldTemplateModal
  },

  props: {
    values: {
      type: Array,
      required: true
    },
    editValue: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true
    },
    showTemplates: {
      type: Boolean,
      default: false,
    }
  },

  setup(props) {
    const optionsCount = ref(3);
    const modalId = computed(() => `select-template-${props.id}`);

    const removeOption = (values, index) => {
      values.splice(index, 1)
    }

    const addOption = (values, value='new-element', label="New Element") => {
      let newValue = value;
      // make sure that `value` is unique
      let i = 1;
      while (values.find(v => v.value === newValue)) {
        newValue = `${value}-${i}`
        ++i;
      }
      values.push({
        label: label,
        value: newValue,
        id: new Date().valueOf()
      })
    }

    const setOptionsCount = (count) => {
      while (count > props.values.length) {
        addOption(props.values);
      }
    }

    const showAddFromTemplate = () => {
      $(`#${modalId.value}`).modal('show');
    }

    const addFromTemplate = (template) => {
      template.options.map(option => {
        addOption(props.values, option.value, option.label);
      })
    }

    return {
      optionsCount,
      modalId,
      addOption,
      addFromTemplate,
      removeOption,
      setOptionsCount,
      showAddFromTemplate,
    }
  }
}
</script>

<style scoped lang="scss">
.no-margin-bot {
  margin-bottom: 0 !important;
}
.middle {
  text-align: right;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// EditorOptionsList.vue?2d1066a6